
import WeatherApplication from './Components/WeatherApp/WeatherApplication.jsx';
import './App.css';

function App() {
  return (
    <div className="App">
      <WeatherApplication/>
    </div>
  );
}

export default App;
